var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1111111{fill:none;}.cls-222222{fill:red;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu_admin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2-2",
    "data-name": "Capa 1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1111111",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222222",
    d: "M100,127.83a49.14,49.14,0,1,1,49.13-49.14A49.2,49.2,0,0,1,100,127.83Zm0-91.66a42.52,42.52,0,1,0,42.52,42.52A42.56,42.56,0,0,0,100,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222222",
    d: "M160.18,171.56H39.82l0-3.35c0-1.18.64-29,23.68-42.35a3.31,3.31,0,0,1,3.32,5.72c-15.47,9-19.21,26.13-20.11,33.36H153.44c-1.77-22.44-21-33.21-21.24-33.32a3.3,3.3,0,1,1,3.16-5.8c1,.55,24.82,13.86,24.82,42.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222222",
    points: "108.74 131.86 100 140.61 91.25 131.86 108.74 131.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222222",
    points: "108.74 164.75 91.25 164.75 100 140.61 108.74 164.75"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAdmin);
export default __webpack_public_path__ + "static/media/menu_admin.5010585a.svg";
export { ForwardRef as ReactComponent };